import { InjectionToken } from '@angular/core';
export const LoggingEnvironment = new InjectionToken('LoggingEnvironment');
//# sourceMappingURL=logging-environment.provider.js.map